import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import SliderOnly from '../slider';
import { Input, Button, message } from 'antd'
import { apiGetCaptchaWord, apiGetPage, apiPostEmailCaptcha, apiPostPhoneCaptcha, apiLoginByPhoneCaptcha, apiLoginByEmailCaptcha, apiCheckEmail, apiCheckPhone } from '../../request/api'
import { useCustomData } from '../../pages/context/loginCustomDataProvider';

interface AcountVerificationProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}

interface loginInfo {
    loginName?: string;
    email?: string;
    phone?: string;
    password?: string;
    verification?: string;
    account?: string;
    emailError?: string;
    phoneError?: string;
    accountError?: string;
    passwordError?: string;
    verificationError?: string;
    enterAccount?: string;
    enterEmail?: string;
    enterPassword?: string;
    enterPasswordAgain?: string;
    enterVerification?: string;
    enterPhone?: string;
    forget?: string;
    getBack?: string;
    next?: string;
    check1?: string;
    verifyIdentity?: string;
    resetPassword?: string;
    orInfo?: string;
    backLogin?: string;
    seccond?: string;
    changeInfo?: string;
    sendVerification?: string;
    verifyIdentityFor?: string;
    sendIdentifying?: string;
    changeInfomation?: string;
}


const AcountVerification: React.FC<AcountVerificationProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [dataType, setDataType] = useState(0)
    const [messageApi, contextHolder] = message.useMessage();
    const [countdown, setCountdown] = useState(0);
    const [captcha, setCaptcha] = useState('');
    const [error, setError] = useState<string | null>('');
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [ok, setOk] = useState(0);
    const [loginInfo, setLoginInfo] = useState<loginInfo>({
        loginName: "", email: "", phone: "", password: "", verification: "", account: "", emailError: "", sendVerification: "",
        phoneError: "", accountError: "", passwordError: "", verificationError: "", enterAccount: "", enterEmail: "",
        enterPassword: "", enterPasswordAgain: "", enterVerification: "", enterPhone: "", forget: "", verifyIdentityFor: "",
        getBack: "", next: "", check1: "", verifyIdentity: "", resetPassword: "", orInfo: "", backLogin: "", seccond: "", changeInfo: "",
        sendIdentifying: '', changeInfomation: ''
    });
    const { getValue, customData } = useCustomData();
    const [identifyingString, setIdentifyingString] = useState(loginInfo.sendVerification)

    useEffect(() => {
        if (customData.length === 0) return; // 数据还没来
        const newLoginInfo: loginInfo = {
            loginName: getValue('loginName'),
            email: getValue('email'),
            phone: getValue('phone'),
            password: getValue('password'),
            verification: getValue('verification'),
            account: getValue('account'),
            emailError: getValue('emailError'),
            phoneError: getValue('phoneError'),
            accountError: getValue('accountError'),
            passwordError: getValue('passwordError'),
            verificationError: getValue('verificationError'),
            enterAccount: getValue('enterAccount'),
            enterEmail: getValue('enterEmail'),
            enterPassword: getValue('enterPassword'),
            enterPasswordAgain: getValue('enterPasswordAgain'),
            enterVerification: getValue('enterVerification'),
            enterPhone: getValue('enterPhone'),
            forget: getValue('forget'),
            getBack: getValue('getBack'),
            next: getValue('next'),
            check1: getValue('check1'),
            verifyIdentity: getValue('verifyIdentity'),
            resetPassword: getValue('resetPassword'),
            orInfo: getValue('orInfo'),
            backLogin: getValue('backLogin'),
            seccond: getValue('seccond'),
            changeInfo: getValue('changeInfo'),
            changeInfomation: getValue('changeInfomation'),
        };
        setIdentifyingString(getValue('sendIdentifying'))
        setLoginInfo(newLoginInfo);
    }, [customData]);

    const changeIdentifying = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setCaptcha(value);
        setError(null); // 输入时清除错误状态
    };
    const phoneRegex = /^\+?[1-9]\d{1,14}$/; // Simple phone regex, adjust as needed

    useEffect(() => {
        // 设置是不是手机号，是手机号就是1，不是手机号就默认是0 
        if (phoneRegex.test(data)) {
            setDataType(1)
        }
        if (countdown > 0) {
            const timer = setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);

            // 清除定时器，防止内存泄漏
            return () => clearTimeout(timer);
        } else if (countdown === 0) {
            // 倒计时结束，启用按钮
            setIsButtonDisabled(false);
        }
    }, [countdown]);

    const handleGetCode = () => {
        if (ok == 0) {
            messageApi.open({
                type: 'error',
                content: '请进行验证',
            });
        } else {
            if (dataType == 0) {
                apiGetCaptchaWord({
                    key: data
                }).then(res => {
                    setIsButtonLoading(true)
                    setTimeout(() => {
                        apiPostEmailCaptcha({
                            captcha: res.data.data,
                            email: data
                        }, {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        }).then(emailres => {
                            messageApi.open({
                                type: 'success',
                                content: emailres.data.data,
                            });
                            setIsButtonDisabled(true);
                            setCountdown(60);
                            setIsButtonLoading(false)
                        })
                    }, 3000);
                }).catch(err => {
                    console.log(err)
                });
            } else {
                apiGetCaptchaWord({
                    key: data
                }).then(res => {
                    console.log('11111')
                    setIsButtonLoading(true)
                    setTimeout(() => {
                        apiPostPhoneCaptcha({
                            captcha: res.data.data,
                            phone: data
                        }, {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        }).then(phoneres => {
                            messageApi.open({
                                type: 'success',
                                content: phoneres.data.data,
                            });
                            setIsButtonDisabled(true);
                            setCountdown(60);
                            setIsButtonLoading(false)
                        })
                    }, 3000);
                }).catch(err => {
                    console.log(err)
                });

            }
        }
    }


    const Verification = () => {
        if (captcha.length < 6) {
            setError('验证码不得小于6位');
            return; // 阻止继续执行
        }
        if (dataType == 0) {
            apiCheckEmail({
                email: data,
                emailCaptcha: captcha
            }).then(res => {
                if (res.data.ret == '40106') {
                    messageApi.open({
                        type: 'error',
                        content: res.data.msg,
                    })
                    return
                }
                messageApi.open({
                    type: 'success',
                    content: '校验成功',
                })
                const token = res.data.data.token;
                localStorage.setItem('userToken', token);
                setTimeout(() => {
                    handleViewChange('resetPassword', data);
                }, 2000); // 2000 毫秒即 2 秒
            })
        } else {
            apiCheckPhone({
                phone: data,
                smsCaptcha: captcha
            }).then(res => {
                if (res.data.ret == '40106') {
                    messageApi.open({
                        type: 'error',
                        content: res.data.msg,
                    })
                    return
                }
                messageApi.open({
                    type: 'success',
                    content: '校验成功',
                })
                const token = res.data.data.token;
                localStorage.setItem('userToken', token);
                setTimeout(() => {
                    handleViewChange('resetPassword', data);
                }, 2000); // 2000 毫秒即 2 秒
            })
        }
    }

    const onSuccess = () => {
        setOk(1)
    };

    const onError = () => {
    };


    return (
        <div>
            {contextHolder}
            <div className='login-header'>{loginInfo.verifyIdentity}</div>
            <div className='login-body'>
                {loginInfo.verifyIdentityFor}{data}{loginInfo.sendVerification}
            </div>
            <p className='' style={{ color: themeColor, cursor: 'pointer' }} onClick={() => {
                handleViewChange("loadAccount", dataType)
            }}>{loginInfo.changeInfomation}</p>
            <div className="slider-wrapper" style={{ marginBottom: '30px' }}>
                <SliderOnly
                    width={360}
                    fragmentSize={40}
                    onSuccess={onSuccess}
                    onError={onError}
                    color={themeColor}
                    tdrage={getValue('tdrage')}
                    inforScuess={getValue('inforScuess')}
                />
            </div>
            <div className='login-body-native'>
                <Input
                    status={error ? 'error' : ''}
                    placeholder={loginInfo.enterVerification}
                    value={captcha}
                    onChange={changeIdentifying}
                />
                <Button disabled={isButtonDisabled} onClick={handleGetCode} loading={isButtonLoading}
                    style={{
                        color: isButtonDisabled ? '#e5e5ee' : 'inherit'
                    }}
                >
                    {countdown > 0 ? `${countdown}` + `${loginInfo.seccond}` : identifyingString}
                </Button>
            </div>
            {error && (
                <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>
                    {error}
                </div>
            )}

            <Button
                type="primary"
                onClick={Verification}
            // 可以根据需求决定是否保留disabled
            // disabled={captcha.length === 0} 
            >
                {loginInfo.check1}
            </Button>
            <div className='or-div'>
                <div className='line'></div>
                <div className='line-text'>{loginInfo.orInfo}</div>
                <div className='line'></div>
            </div>
            <button className='line-button' onClick={() => handleViewChange("mainLogin")} style={{ color: themeColor }}>{loginInfo.backLogin}</button>
        </div>
    )

};

export default AcountVerification;
